import { Injectable } from '@angular/core';
import {PaywallModule} from '../../paywall.module';
import {ItemManagerService} from '@src/app/services/itemManager/item-manager.service';
import {Item} from '@src/app/models/Item';
import {EsBsModalService} from '@src/app/services/bsModalService/bs-modal.service';

@Injectable({
  providedIn: PaywallModule
})
export class PaywallUserService {

  constructor(private im: ItemManagerService, private bsModal: EsBsModalService) { }

  private _iconChangedObjectsCounter:number = 0;

  get iconChangedObjectsCounter():number{
    return this._iconChangedObjectsCounter;
  }

  isUserNewFreemium():boolean{
    return window['PAYWALL_ENABLED'] && window['PAYWALL_ICONS_ENABLED'];
  }

  initChangedIconObjectsCounter(){
    this._iconChangedObjectsCounter = this.im.getAllItems().filter((i:Item)=>{
      return i.config.getInputProp('customIcon', 'defaultValue')
    }).length;
  }
  incrementChangedIconObjectsCounter(){
    this._iconChangedObjectsCounter++;
  }
  decrementChangedIconObjectsCounter(){
    this._iconChangedObjectsCounter--;
  }

  openWarningModal(){
    this.bsModal.openModal({
      modalId: '#paywall-icon-warning'
    });
  }
  openLastWarningModal(){
    this.bsModal.openModal({
      modalId: '#paywall-icon-last-warning'
    });
  }
  // openErrorModal(){
  //   this.bsModal.openModal({
  //     modalId: '#paywall-icon-last-warning'
  //   });
  // }
}
